<template>
    <div>
        <script type="application/javascript" src='https://api.mapbox.com/mapbox.js/plugins/leaflet-fullscreen/v1.0.1/Leaflet.fullscreen.min.js'></script>
        <div id="map" v-if="showMap">
            <div class="loader-container">
            <div class="loader"></div>
            </div>
        </div>
    </div>
</template>
<script>

import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from 'axios';
import { kml } from "@tmcw/togeojson";
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {    
    // multiple ids entered in
    props: ['id', 'electorate', 'colours'],
    data() {
        return {
            showMap: true,
            map: null,
        }
    },
    methods: {
        setupLeafletMap: function () {
            // show multiple maps
            this.$emit('setLoading', true);
            // call api multiple times
            // const url = `ElectorateMaps/ElectorateMap?id=${this.id[0]}`;
            const urls = this.id.map(i => `ElectorateMaps/ElectorateMap?id=${i}`);

            if (this.map !== null) {
                this.map.remove();
                this.map = null;
            }

            axios.all(urls.map(u => axios.get(`api/${u}`))).then(all => {
                const geoDatas = [];
                all.forEach((response) => {
                    const data = response.data;
                    // put each map on
                    if (data == null) {
                        this.showMap = false;
                        return;
                    }
                    // convert from kml to geojson
                    const xml = atob(data.GeoData);
                    const geoData = kml(new DOMParser().parseFromString(xml, "text/xml"));
                    // remove Points
                    geoData.features = geoData.features.filter(f => f.geometry.type !== 'Point');
                    geoDatas.push(geoData);
                });

                if (this.map == null) {
                    this.map = L.map("map", { 
                        attributionControl: false,
                    });
                    this.map.on('fullscreenchange', () => {
                        if (this.map.isFullscreen()) {
                            document.getElementsByClassName('handbook-link_skipToContent')[0].style.height = 0;
                            document.getElementById('toolbar').style.zIndex = 0;
                            document.getElementsByTagName('footer')[0].style.zIndex = -1;
                        } else {
                            document.getElementsByClassName('handbook-link_skipToContent')[0].style.height = null;
                            document.getElementById('toolbar').style.zIndex = 3;
                            document.getElementsByTagName('footer')[0].style.zIndex = 3;
                        }
                    });
                    this.map.addControl(new L.Control.Fullscreen({ pseudoFullscreen: true }));
                }
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);                    
                geoDatas.forEach((geoData, i) => {
                    const jsonLayer = L.geoJSON(geoData, {
                        style: () => {
                            return { color: this.colours[i]};
                        }
                    }).addTo(this.map);
                    if (i === 0) {
                        this.map.fitBounds(jsonLayer.getBounds(), { padding: [110, 110] });
                        this.map.setView(jsonLayer.getBounds().getCenter());
                    }
                });

                this.$emit('setLoading', false);                    
            });
        }
    },
    mounted() {
        this.setupLeafletMap();
    },
    unmounted() {
        if (this.map !== null) {
            this.map.remove();
            this.map = null;
        }
    },
    watch: {
        id: function() {
            this.setupLeafletMap();
        }
    }
}
</script>
<style scoped>
    #map { height: 720px; }
    .loader-container { padding-top: 145px; }
</style>
<style>
    @import 'https://api.mapbox.com/mapbox.js/plugins/leaflet-fullscreen/v1.0.1/leaflet.fullscreen.css';
</style>